export default {
  totalRow:{
    backgroundColor: 'lightgrey',
  },
  totalColumn: {
    backgroundColor: 'lightgrey',
    fontWeight: 'bold',
  },
  total: {
    fontWeight: 'bold',
  },
  dateColHeader: {
    textAlign: 'center',
  },
  dateCol: {
    textAlign: 'center',
  },
  totalCol: {
    textAlign: 'center',
  },
  subGroups: {
    display: 'flex',
  },
  subGroupNameButton: {
    margin: 10,
    flex: 1,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  // selectedSubGroupNameButton: {
  //   margin: 10,
  //   flex: 1,
  //   color: 'blue',
  //   backgroundColor: 'blue',
  // },
};



// WEBPACK FOOTER //
// ./src/components/Reports/DetailedItemBreakdownReport/styles.js